/**
 * Strings do cadastro sem espera (E189.F2, ADR-0138) — namespace `abertura.cadastro.*`.
 *
 * O "Enviar e seguir" do Conferir, o caso que se cadastra sozinho e os cadastros em andamento no
 * topo das listas da equipe e do portal. Valem as regras do `pt-BR.ts`: nenhum termo técnico
 * interno e nenhuma string de UI hardcoded em componente.
 */
export const ptBRCadastroSemEspera = {
  enviarESeguir: 'Enviar e seguir',
  enviando: 'Enviando…',
  enviarESeguirAjuda:
    'Se preferir, use "Enviar e seguir": o cadastro termina sozinho e esta tela mostra o recibo, com o que faltar.',
  erroAoEnviar: 'Não foi possível enviar. Tente de novo.',
  titulo: 'Cadastrando o caso',
  texto:
    'O cadastro termina sozinho quando a leitura dos arquivos acabar, e esta tela mostra o recibo com o que faltar. Você pode voltar aos casos ou cadastrar o próximo: o caso fica em "Cadastros em andamento".',
  etapa: {
    lendo_documentos: 'Lendo documentos',
    conferindo_imagens: 'Conferindo as imagens',
    conferindo_fotos: 'Conferindo as fotos',
    concluindo: 'Concluindo o cadastro',
  },
  contagem: '{lidos} de {total}',
  precisaTitulo: 'Precisa da sua conferência',
  novoCaso: 'Cadastrar outro caso',
  lista: {
    titulo: 'Cadastros em andamento',
    colunaCaso: 'Caso',
    colunaProcesso: 'Processo ou pasta',
    colunaSituacao: 'Situação',
    abrir: 'Abrir',
    abrirCaso: 'Abrir o caso {codigo}',
  },
} as const;
